import { offerCodeEnum } from '@@viewEnums';

const middleWorkflows = (
  offerCode,
  numberPricings = 1,
  displayActivePolicy = false,
  displayGamme = true,
  creatorIsBroker = false,
  skipSimulationNeeds = false
) => {
  if (offerCode === offerCodeEnum.INDIVIDUAL_HEALTH) {
    return [
      {
        label: 'Date d\'effet du contrat',
        viewId: 'SIMULATION_EFFECT_DATE',
        group: '1'
      },
      {
        label: 'Données contrat',
        viewId: 'SIMULATION_CUSTOMER_GRANTEES',
        group: '1'
      },
      ...(displayGamme
        ? [
          {
            label: 'Choix de la gamme',
            viewId: 'SIMULATION_PRODUCT',
            group: '1'
          }
        ]
        : []),
      ...(skipSimulationNeeds
        ? []
        : [
          {
            label: 'Recueil du besoin',
            viewId: 'SIMULATION_NEEDS',
            group: '1'
          }
        ]),
      {
        label: 'Niveaux de garanties et tarifs',
        viewId: 'SIMULATION_PRICINGS_INDIVIDUAL_HEALTH',
        group: '1'
      },
      ...(__CUSTOM__ === 'pavillon' // eslint-disable-line no-undef
        ? [
          {
            label: 'Informations complémentaires',
            viewId: 'SIMULATION_PAVILLON_INFORMATION',
            group: '1'
          }
        ]
        : []),
      {
        label: 'Synthèse',
        viewId: 'SIMULATION_RECAP',
        group: '1'
      },
      ...(numberPricings > 1
        ? [
          {
            label: 'Choix final de la formule',
            viewId: 'SOUSCRIPTION_PRICING',
            group: '2'
          }
        ]
        : []),
      {
        label: 'Coordonnées',
        viewId: 'SOUSCRIPTION_INFORMATIONS',
        group: '2'
      },
      ...(displayActivePolicy
        ? [
          {
            label: 'Couverture actuelle',
            viewId: 'SOUSCRIPTION_ACTIVE_POLICY',
            group: '2'
          }
        ]
        : []),
      {
        label: 'Adhérent & bénéficiaires',
        viewId: 'SOUSCRIPTION_CUSTOMER_GRANTEES',
        group: '2'
      },
      ...(!['mh', 'mhexpat'].includes(__CUSTOM__) && !creatorIsBroker // eslint-disable-line no-undef
        ? [
          {
            label: 'Remises commerciales',
            viewId: 'SOUSCRIPTION_WAIVER_STAGES',
            group: '2'
          }
        ]
        : []),
      {
        label: 'Paiement & remboursement',
        viewId: 'SOUSCRIPTION_PAYMENT_REFUND',
        group: '2'
      },
      {
        label: 'Récapitulatif',
        viewId: 'SOUSCRIPTION_RECAP',
        group: '2'
      },
      {
        label: 'Envoi des documents',
        viewId: 'SOUSCRIPTION_SUPPORTING_DOCUMENTS',
        group: '2'
      }
    ];
  } else if (offerCode === offerCodeEnum.INDIVIDUAL_PROTECTION_DAILY_BENEFIT) {
    return [
      {
        label: 'Date d\'effet du contrat',
        viewId: 'SIMULATION_EFFECT_DATE',
        group: '1'
      },
      {
        label: 'Données contrat',
        viewId: 'SIMULATION_CUSTOMER_GRANTEES',
        group: '1'
      },
      {
        label: 'Niveaux de garanties et tarifs',
        viewId: 'SIMULATION_PRICINGS_DAILY_BENEFIT',
        group: '1'
      },
      {
        label: 'Synthèse',
        viewId: 'SIMULATION_RECAP',
        group: '1'
      },
      {
        label: 'Coordonnées',
        viewId: 'SOUSCRIPTION_INFORMATIONS',
        group: '2'
      },
      ...(displayActivePolicy
        ? [
          {
            label: 'Couverture actuelle',
            viewId: 'SOUSCRIPTION_ACTIVE_POLICY',
            group: '2'
          }
        ]
        : []),
      {
        label: 'Adhérent & bénéficiaires',
        viewId: 'SOUSCRIPTION_CUSTOMER_GRANTEES',
        group: '2'
      },
      {
        label: 'Paiement & remboursement',
        viewId: 'SOUSCRIPTION_PAYMENT_REFUND',
        group: '2'
      },
      {
        label: 'Récapitulatif',
        viewId: 'SOUSCRIPTION_RECAP',
        group: '2'
      },
      {
        label: 'Envoi des documents',
        viewId: 'SOUSCRIPTION_SUPPORTING_DOCUMENTS',
        group: '2'
      }
    ];
  } else if (offerCode === offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION) {
    return [
      {
        label: 'Date d\'effet du contrat',
        viewId: 'SIMULATION_EFFECT_DATE',
        group: '1'
      },
      {
        label: 'Données contrat',
        viewId: 'SIMULATION_CUSTOMER_GRANTEES',
        group: '1'
      },
      ...(skipSimulationNeeds
        ? []
        : [
          {
            label: 'Recueil du besoin',
            viewId: 'SIMULATION_NEEDS',
            group: '1'
          }
        ]),
      {
        label: 'Niveaux de garanties et tarifs',
        viewId: 'SIMULATION_PRICINGS_SELF_WORKER',
        group: '1'
      },
      {
        label: 'Synthèse',
        viewId: 'SIMULATION_RECAP',
        group: '1'
      },
      {
        label: 'Coordonnées',
        viewId: 'SOUSCRIPTION_INFORMATIONS',
        group: '2'
      },
      ...(displayActivePolicy
        ? [
          {
            label: 'Couverture actuelle',
            viewId: 'SOUSCRIPTION_ACTIVE_POLICY',
            group: '2'
          }
        ]
        : []),
      {
        label: 'Adhérent & bénéficiaires',
        viewId: 'SOUSCRIPTION_CUSTOMER_GRANTEES',
        group: '2'
      },
      {
        label: 'Paiement & remboursement',
        viewId: 'SOUSCRIPTION_PAYMENT_REFUND',
        group: '2'
      },
      {
        label: 'Récapitulatif',
        viewId: 'SOUSCRIPTION_RECAP',
        group: '2'
      },
      {
        label: 'Envoi des documents',
        viewId: 'SOUSCRIPTION_SUPPORTING_DOCUMENTS',
        group: '2'
      }
    ];
  } else if (offerCode === offerCodeEnum.GROUP_HEALTH) {
    return [
      {
        label: 'Entreprise',
        viewId: 'SIMULATION_COMPANY',
        group: '1'
      },
      {
        label: 'Démographie',
        viewId: 'SIMULATION_DEMOGRAPHY',
        group: '1'
      },
      {
        label: 'Date d\'effet du contrat',
        viewId: 'SIMULATION_EFFECT_DATE',
        group: '1'
      },
      {
        label: 'Choix de l\'offre',
        viewId: 'SIMULATION_PRODUCT',
        group: '1'
      },
      ...(skipSimulationNeeds
        ? []
        : [
          {
            label: 'Recueil du besoin',
            viewId: 'SIMULATION_NEEDS',
            group: '1'
          }
        ]),
      {
        label: 'Niveaux de garanties et tarifs',
        viewId: 'SIMULATION_PRICINGS_GROUP_HEALTH',
        group: '1'
      },
      {
        label: 'Synthèse',
        viewId: 'SIMULATION_RECAP',
        group: '1'
      },
      ...(numberPricings > 1
        ? [
          {
            label: 'Choix final de la formule',
            viewId: 'SOUSCRIPTION_PRICING',
            group: '2'
          }
        ]
        : []),
      {
        label: 'Contact',
        viewId: 'SOUSCRIPTION_COMPANY',
        group: '2'
      },
      ...(displayActivePolicy
        ? [
          {
            label: 'Couverture actuelle',
            viewId: 'SOUSCRIPTION_ACTIVE_POLICY',
            group: '2'
          }
        ]
        : []),
      {
        label: 'Paiement & remboursement',
        viewId: 'SOUSCRIPTION_PAYMENT_REFUND',
        group: '2'
      },
      {
        label: 'Récapitulatif',
        viewId: 'SOUSCRIPTION_RECAP',
        group: '2'
      },
      {
        label: 'Envoi des documents',
        viewId: 'SOUSCRIPTION_SUPPORTING_DOCUMENTS',
        group: '2'
      }
    ];
  } else if (offerCode === offerCodeEnum.GROUP_PROTECTION) {
    return [
      {
        label: 'Entreprise',
        viewId: 'SIMULATION_COMPANY_GROUP_PROTECTION',
        group: '1'
      },
      {
        label: 'Démographie',
        viewId: 'SIMULATION_DEMOGRAPHY_GROUP_PROTECTION',
        group: '1'
      },
      {
        label: 'Données contrat',
        viewId: 'SIMULATION_CONTRACT_DATA_GROUP_PROTECTION',
        group: '1'
      },
      {
        label: 'Offre',
        viewId: 'SIMULATION_OFFER_GROUP_PROTECTION',
        group: '1'
      },
      {
        label: 'Recueil du besoin',
        viewId: 'SIMULATION_NEEDS_GROUP_PROTECTION',
        group: '1'
      },
      {
        label: 'Garanties',
        viewId: 'SIMULATION_WARRANTIES_GROUP_PROTECTION',
        group: '1'
      },
      {
        label: 'Synthèse',
        viewId: 'SIMULATION_RECAP_GROUP_PROTECTION',
        group: '1'
      },
      {
        label: 'Contact',
        viewId: 'SOUSCRIPTION_COMPANY_GROUP_PROTECTION',
        group: '2'
      },
      ...(displayActivePolicy
        ? [
          {
            label: 'Couverture actuelle',
            viewId: 'SOUSCRIPTION_ACTIVE_POLICY_GROUP_PROTECTION',
            group: '2'
          }
        ]
        : []),
      {
        label: 'Paiement & remboursement',
        viewId: 'SOUSCRIPTION_PAYMENT_REFUND_GROUP_PROTECTION',
        group: '2'
      },
      {
        label: 'Récapitulatif',
        viewId: 'SOUSCRIPTION_RECAP_GROUP_PROTECTION',
        group: '2'
      },
      {
        label: 'Envoi des documents',
        viewId: 'SOUSCRIPTION_SUPPORTING_DOCUMENTS_GROUP_PROTECTION',
        group: '2'
      }
    ];
  } else {
    return [];
  }
};

export default middleWorkflows;
